import ThreadPage from "./Thread";
export default ThreadPage;
